import {
  hexToRgb
} from 'helpers/colors';

import colors from 'constants/colors';

angular.module('gym.calendar').controller('WeeklyAgendaCtrl', ["gym", "$scope", "$rootScope", "$state", "$filter", "EmploymentService", "EventService", "TrainersService", "loadingAnimation", "CalendarLastVisitedViewService", "CwStorage", "ContrastColor", "CalendarData", "isFreeTrials", "locations", "selectedLocation", "eventTypes", "styles", function(gym, $scope, $rootScope, $state, $filter, EmploymentService, EventService, TrainersService, loadingAnimation, CalendarLastVisitedViewService, CwStorage, ContrastColor, CalendarData, isFreeTrials, locations, selectedLocation, eventTypes, styles) {
  var eventColor, getEvents, getEventsDebounced, groupEvents;
  moment.updateLocale('en', {
    week: {
      dow: $scope.gym.gym_booking_detail.calendar_start_wday
    }
  });
  $scope.permissions = EmploymentService.get().permissions;
  CalendarLastVisitedViewService.set($state.current.name);
  $scope.queryParams = {
    general_filter: CwStorage.getItem('calendarGeneralFilter')
  };
  $scope.locations = locations;
  $scope.instructors = TrainersService.get();
  $scope.eventTypes = eventTypes;
  $scope.styles = styles;
  $scope.selectedLocations = _.compact([selectedLocation]);
  $scope.selectedInstructors = [];
  $scope.selectedEventTypes = [];
  $scope.selectedStyles = [];
  $scope.date = moment();
  $scope.isFreeTrials = isFreeTrials;
  $scope.unableToManageOtherContacts = !$scope.permissions.manage_other_contacts;
  $scope.glossary = gym.attributes.glossary;
  $scope.getSpacesLeftLabel = function(event, isFreeTrials) {
    var ref, vacancies;
    if ((ref = event.participant_limit) === 0 || ref === (void 0) || ref === null) {
      return '-';
    }
    vacancies = isFreeTrials ? event.prospect_vacancies_count : event.vacancies_count;
    return vacancies;
  };
  $scope.currentView = isFreeTrials ? 'freeTrials' : 'weeklyAgenda';
  $scope.page = isFreeTrials ? 'Free trials' : 'Weekly agenda';
  $scope.displayItems = function(items) {
    if (!items) {
      return '';
    }
    return items.join(', ');
  };
  $scope.eventColor = eventColor = function(color) {
    return color || colors.primary;
  };
  $scope.fontColor = function(color) {
    return ContrastColor.get(eventColor(color), {
      darkColor: '#303030'
    });
  };
  $scope.cardColor = function(color) {
    var rgb;
    rgb = hexToRgb(color || colors.primary) || hexToRgb(colors.primary);
    return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
  };
  if ($scope.unableToManageOtherContacts) {
    $scope.selectedInstructors = [
      {
        id: window.currentUser.id,
        name: `${window.currentUser.first_name} ${window.currentUser.last_name}`
      }
    ];
  }
  $scope.goToCalendar = function() {
    return $state.go('gym.calendar');
  };
  $scope.toDate = function(date) {
    $scope.date = date;
    return getEvents();
  };
  groupEvents = function(events) {
    return _.chain(events).map(function(event) {
      event.date = moment(event.start, 'YYYY/MM/DD HH:mm').startOf('day').format('X');
      event.isCancelled = !!event.cancelled;
      return event;
    }).groupBy('date').value();
  };
  getEvents = function() {
    var end, params, selectedEventType, selectedInstructor, selectedStyle, start;
    start = $scope.date.clone().startOf('week');
    end = $scope.date.clone().endOf('week');
    selectedLocation = $scope.selectedLocations[0] || {};
    selectedInstructor = $scope.selectedInstructors[0] || {};
    selectedEventType = $scope.selectedEventTypes[0] || {};
    selectedStyle = $scope.selectedStyles[0] || {};
    params = {
      start: start.format('X'),
      end: end.format('X'),
      location_id: selectedLocation.id,
      instructor_id: selectedInstructor.id,
      event_type_id: selectedEventType.id,
      style_id: selectedStyle.id,
      prospect_spaces_available: $scope.isFreeTrials && 1,
      view: 'list'
    };
    angular.extend(params, $scope.queryParams);
    $scope.title = `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
    loadingAnimation.show();
    return CalendarData.getList(params).then(function(events) {
      loadingAnimation.hide();
      $scope.eventsByDay = groupEvents(events.plain());
      return $scope.eventsCount = events.length;
    });
  };
  getEvents();
  $rootScope.$on('calendar:updated', function() {
    return getEvents();
  });
  getEventsDebounced = _.debounce(function() {
    return getEvents();
  }, 300);
  $scope.onParamsChange = function() {
    CwStorage.setItem('calendarGeneralFilter', $scope.queryParams.general_filter);
    return getEvents();
  };
  $scope.isFiltersAvailable = function() {
    return $scope.locations.length > 1 || $scope.instructors.length > 1;
  };
  $scope.onLocationsChange = function(locations) {
    var location;
    location = locations[0] || {};
    CwStorage.setItem('selectedLocation', location.id);
    $scope.selectedLocations = locations;
    return getEventsDebounced();
  };
  $scope.onInstructorsChange = function(instructors) {
    var instructor;
    instructor = instructors[0] || {};
    $scope.selectedInstructors = instructors;
    return getEventsDebounced();
  };
  $scope.onEventTypesChange = function(eventTypes) {
    $scope.selectedEventTypes = eventTypes;
    return getEventsDebounced();
  };
  $scope.onStylesChange = function(styles) {
    $scope.selectedStyles = styles;
    return getEventsDebounced();
  };
  return $scope.showAttendees = function(event) {
    return EventService.showAttendees(event);
  };
}]);
